import { useImageFromUri } from '@visikon/utils/src/utils';
import * as React from 'react';
import { useEffect } from 'react';
import { Fader } from '../../common/Fader';
import Thumbnail from '../../components/Thumbnail';
import { EditButton } from '../../components/edit/EditButton';
import { MoveButton } from '../../components/edit/MoveButton';
import { Chevron } from '../../components/styled/Chevron';
import * as Styles from '../../components/styled/DetailsCard';
import { FAQSection } from '../../reducers/resourcesReducer';
import * as FaqStyles from './FaqCardComponent.styles';

const renderTextWithNewline = (text: string) => {
  return text?.split('\n').map((t) => {
    if (t && t.length > 0) {
      return (
        <p key={t} style={{ lineHeight: '1.5' }}>
          {t}
        </p>
      );
    }
    return null;
  });
};

const renderDetails = (info: FAQSection['questions'][0]) => {
  return (
    <Fader key={info.question}>
      <FaqStyles.FaqDetails>
        <div style={{ alignItems: 'center', lineHeight: '1.5' }}>
          <span style={{ maxWidth: '100%' }}>{info.question}</span>
        </div>
        <div>{renderTextWithNewline(info.answer)}</div>
      </FaqStyles.FaqDetails>
    </Fader>
  );
};

interface IProps {
  faq: FAQSection;
  isOpen: boolean;
  onClick: () => void;
  length: number;
  currentPosition: number;
}

export const FaqCardComponent = ({ faq, isOpen, onClick, length, currentPosition }: IProps) => {
  const contentRef = React.useRef<HTMLElement>(null);

  const uri = faq.thumbnail ? useImageFromUri(faq.thumbnail._id) : '';
  const isFirst = currentPosition === 0;
  const isLast = currentPosition === length - 1;

  useEffect(() => {
    if (isOpen && contentRef.current) {
      contentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [isOpen, contentRef.current]);

  return (
    <Fader>
      <section style={{ padding: 'unset', margin: 'unset' }} ref={contentRef}>
        <div style={{ display: 'flex', gap: '18px', alignItems: 'center', marginTop: '24px' }}>
          <Styles.DetailsCard onClick={onClick}>
            <Thumbnail thumbUrl={uri} alt="" />
            <Styles.NameContainer>
              <Styles.DetailsCardName>{faq.name}</Styles.DetailsCardName>
            </Styles.NameContainer>
            <Chevron isOpen={isOpen} />
          </Styles.DetailsCard>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {!isFirst && <MoveButton direction="up" currentIndex={currentPosition} contentType="faq" />}
            {!isLast && <MoveButton direction="down" currentIndex={currentPosition} contentType="faq" />}
            <EditButton currentIndex={currentPosition} contentType="faq" />
          </div>
        </div>
        {isOpen && <Styles.DetailsCardContainer>{faq.questions.map(renderDetails)}</Styles.DetailsCardContainer>}
      </section>
    </Fader>
  );
};
